import axios from "axios";

let client = axios.create({
	withCredentials: true,
	withXSRFToken: true,
	headers: {
		"X-Requested-With": "XMLHttpRequest",
	},
	paramsSerializer: p => {
		return window.Qs.stringify(p, {
			arrayFormat: "brackets",
		});
	},
});

const errorHandler = (error) => {
	let status = error?.response?.status;
	let redirect = error?.response?.data?.redirect;

	if (
		status === 302 &&
		redirect
	) {
		window.app.$router.replace({path: redirect});
	}

	if (
		status === 401 &&
		window.app.$store.state.authStore.authed
	) {
		window.app.$store?.dispatch("authStore/logout");
	}

	// if ([403, 404, 500].indexOf(status) > -1) {
	// 	window.app.$store?.commit("errorsStore/ERROR", error);
	// }

	throw error;
};

client.interceptors.request.use((config) => {
	window.app.$store?.commit("errorsStore/RESET");
	config.headers["X-Socket-ID"] = window.Echo?.socketId();
	config.params = config.params || {};
	config.params.appMode = window.app.$store?.state?.auth?.authed?.appMode || window.app.$router.currentRoute.query.appMode;
	config.params.session = window.sessionId;
	config.metadata = {
		startTime: new Date(),
		minResponseDuration: client.minResponseDuration,
		uniqueRequestName: client.uniqueRequestName,
	};

	client.minResponseDuration = 0;

	let cancellationSource = client.cancellationSources[client.uniqueRequestName] ?? client.cancellationSource;
	config.cancelToken = cancellationSource?.token;
	client.uniqueRequestName = null;

	return config;
});

client.interceptors.response.use(async (response) => {
	response.config.metadata.endTime = new Date();
	response.config.metadata.duration = response.config.metadata.endTime - response.config.metadata.startTime;
	response.config.metadata.offset = (response.config.metadata.minResponseDuration || 0) - response.config.metadata.duration;

	delete client.cancellationSources[response.config.metadata.uniqueRequestName];

	if (response.config.metadata.offset > 0) {
		await new Promise((resolve) => setTimeout(resolve, response.config.metadata.offset));
	}

	if (window.app.$store?.state?.authStore) {
		window.app.$store.dispatch("authStore/startSessionTimer", response.headers["session-expires"] || null);
	}
	window.octaneMonitor?.update(response.data.debug);
	window.phpdebugbar?.ajaxHandler?.handle(response.request);

	return response;
}, errorHandler);

client.cancellationSources = {};

client.cancelToken = function () {
	return axios.CancelToken.source();
};

client.unique = function (uniqueRequestName = null) {
	let cancellationSource = client.cancelToken();
	client.uniqueRequestName = uniqueRequestName;
	if (!uniqueRequestName) {
		client.cancellationSource = cancellationSource;
		return client;
	}
	client.cancel(uniqueRequestName);
	client.cancellationSources[uniqueRequestName] = cancellationSource;

	return client;
};

client.cancel = function (uniqueRequestName = null) {
	let source = client.cancellationSources[uniqueRequestName] ?? client.cancellationSource;
	source?.cancel();
	return client;
};

client.delayResponse = function (minResponseDuration = 0) {
	client.minResponseDuration = minResponseDuration;
	return client;
};

export const httpClient = client;
